import React from 'react';
import { Link } from 'react-router-dom';
import LegalPage, { Section, Champ } from '../components/LegalPage';
import { EDITEUR, HEBERGEUR, PROTECTION_DONNEES } from '../legalInfo';

export default function MentionsLegales() {
  return (
    <LegalPage
      titre="Mentions légales"
      chapo="Informations légales relatives au site jalonne.fr et à la plateforme Jalonne, conformément à l'article 6-III de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN)."
    >
      <Section titre="1. Éditeur du site">
        <dl className="legal-dl">
          <dt>Dénomination</dt>
          <dd><Champ valeur={EDITEUR.raisonSociale} attendu="dénomination de l'entreprise" /></dd>
          <dt>Forme juridique</dt>
          <dd><Champ valeur={EDITEUR.formeJuridique} attendu="forme juridique" /></dd>
          {!EDITEUR.entrepriseIndividuelle && (
            <>
              <dt>Capital social</dt>
              <dd><Champ valeur={EDITEUR.capital} attendu="capital social" /></dd>
            </>
          )}
          <dt>{EDITEUR.entrepriseIndividuelle ? 'Établissement principal' : 'Siège social'}</dt>
          <dd><Champ valeur={EDITEUR.siege} attendu="adresse de l'établissement" /></dd>
          <dt>Immatriculation</dt>
          <dd>
            <Champ valeur={EDITEUR.registre} attendu="registre d'immatriculation" /> — SIREN{' '}
            <Champ valeur={EDITEUR.siren} attendu="n° SIREN" />
            {EDITEUR.siret ? ` — SIRET ${EDITEUR.siret}` : ''}
          </dd>
          <dt>TVA</dt>
          <dd>
            {EDITEUR.franchiseTva
              ? 'TVA non applicable, article 293 B du code général des impôts'
              : <Champ valeur={EDITEUR.tvaIntracom} attendu="n° de TVA intracommunautaire" />}
          </dd>
          <dt>Directeur de la publication</dt>
          <dd><Champ valeur={EDITEUR.directeurPublication} attendu="nom du directeur de la publication" /></dd>
          <dt>Contact</dt>
          <dd>
            <Champ valeur={EDITEUR.email} attendu="email de contact" />
            {EDITEUR.telephone ? ` — ${EDITEUR.telephone}` : ''}
          </dd>
        </dl>
        <p>
          Le nom commercial <strong>Jalonne</strong> désigne la plateforme de suivi de chantier
          éditée et exploitée par l'entreprise ci-dessus, ci-après « l'Éditeur ».
        </p>
      </Section>

      <Section titre="2. Hébergement">
        <p>Le site et les données de la plateforme sont hébergés par :</p>
        <dl className="legal-dl">
          <dt>Hébergeur</dt>
          <dd><Champ valeur={HEBERGEUR.nom} attendu="nom de l'hébergeur" /></dd>
          <dt>Adresse</dt>
          <dd><Champ valeur={HEBERGEUR.adresse} attendu="adresse de l'hébergeur" /></dd>
          <dt>Téléphone</dt>
          <dd><Champ valeur={HEBERGEUR.telephone} attendu="téléphone de l'hébergeur" /></dd>
        </dl>
        <p>Les données sont hébergées au sein de l'Union européenne.</p>
      </Section>

      <Section titre="3. Propriété intellectuelle">
        <p>
          La plateforme Jalonne, sa structure, son code source, ses interfaces, ses textes, sa
          charte graphique et ses éléments distinctifs sont la propriété exclusive de l'Éditeur et
          sont protégés par le droit de la propriété intellectuelle. Toute reproduction,
          représentation, adaptation ou exploitation, totale ou partielle, sans autorisation écrite
          préalable, est interdite.
        </p>
        <p>
          Les contenus publiés par les entreprises clientes (photos de chantier, descriptions,
          logos, noms des intervenants) demeurent la propriété de leurs titulaires respectifs.
          L'Éditeur n'en acquiert aucun droit de propriété : il ne dispose que des droits d'usage
          strictement nécessaires à la fourniture du service, décrits dans les{' '}
          <Link to="/cgu">conditions générales d'utilisation</Link>.
        </p>
      </Section>

      <Section titre="4. Responsabilité sur les contenus publiés">
        <p>
          Les pages publiques de chantier sont alimentées par les entreprises clientes, qui sont
          seules responsables des contenus qu'elles y publient. Conformément aux articles 6-I-2 et
          6-I-3 de la LCEN, l'Éditeur agit à l'égard de ces contenus en qualité d'hébergeur : il
          n'est pas tenu à une obligation générale de surveillance, mais retire promptement tout
          contenu manifestement illicite qui lui est signalé.
        </p>
        <h3>Signaler un contenu illicite</h3>
        <p>
          Tout signalement peut être adressé à{' '}
          <Champ valeur={EDITEUR.email} attendu="email de contact" />. Pour être traité utilement,
          il doit préciser la date du signalement, l'identité du notifiant, l'adresse (URL) précise
          du contenu contesté et les motifs pour lesquels il devrait être retiré.
        </p>
      </Section>

      <Section titre="5. Données personnelles">
        <p>
          Le traitement des données personnelles est décrit dans la{' '}
          <Link to="/confidentialite">politique de confidentialité</Link>. Les conditions dans
          lesquelles l'Éditeur traite, pour le compte de ses clients, les données des personnes
          concernées par les chantiers figurent dans l'{' '}
          <Link to="/sous-traitance">accord de sous-traitance</Link> (article 28 du RGPD).
        </p>
        <p>
          Contact pour l'exercice des droits :{' '}
          <Champ valeur={PROTECTION_DONNEES.contactEmail} attendu="email dédié aux demandes RGPD" />.
        </p>
      </Section>

      <Section titre="6. Cookies">
        <p>
          La plateforme n'utilise aucun cookie publicitaire ni traceur de mesure d'audience. Les
          modalités de stockage local nécessaires au fonctionnement du service sont détaillées dans
          la <Link to="/confidentialite">politique de confidentialité</Link>.
        </p>
      </Section>

      <Section titre="7. Droit applicable">
        <p>
          Les présentes mentions légales sont régies par le droit français. Les conditions
          contractuelles applicables à l'utilisation du service figurent dans les{' '}
          <Link to="/cgu">CGU</Link> et les <Link to="/cgv">CGV</Link>.
        </p>
      </Section>
    </LegalPage>
  );
}
